import mome from 'moment'

const format = function (str) {
  let date = new Date(str)
  return mome(date).format('DD.MM.YYYY HH:mm:ss')
}
export default {
  format
}



// WEBPACK FOOTER //
// ./src/format/date.js